 <div class="main">
    <div dir="rtl">
        <h2 style="text-align: center;">צדיקים</h2>

        <div class="newBtn">
            <p>
                <a class="btn btn-primary" routerLink="/admin/tzadikim/new">New Tzadik</a>
            </p>
        </div>
        <div class="filter">
            <div class="filter2">
                <input class="form-control" placeholder="search" (keyup)="onSearch()" [(ngModel)]="filter" />
            </div>
        </div>

        <div class="tableHolder">
            <div class="tbl" dir="rtl">
                <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource">
                        <ng-container matColumnDef="המכונה בפי כל">
                          <th mat-header-cell *matHeaderCellDef style="text-align: center;">המכונה בפי כל</th>
                          <td mat-cell *matCellDef="let m" style="text-align: center;"> {{ m.title }} </td>
                        </ng-container>
                    
                        <ng-container matColumnDef="שם משפחה">
                          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> שם משפחה </th>
                          <td mat-cell *matCellDef="let m" style="text-align: center;">{{m.subTitle}} </td>
                        </ng-container>

                        
                        <ng-container matColumnDef="שטאט">
                            <th mat-header-cell *matHeaderCellDef style="text-align: center;">שטאט </th>
                            <td mat-cell *matCellDef="let m" style="text-align: center;">{{m.mkm.city.cityY + ', ' +m.mkm.city.state.stateY}} </td>
                          </ng-container>

                          <ng-container matColumnDef='לע"נ'>
                            <th mat-header-cell *matHeaderCellDef style="text-align: center;">לע"נ</th>
                            <td mat-cell *matCellDef="let m" style="text-align: center;">{{
                            m.tzadikTitle + ' ' + m.tzadikFirstName + ' '
                            + m.tzadikBN + ' ' + m.fathersTitle + ' '
                            + m.fatherName + ' ' + m.tzadikEndTitle
                                }} </ng-container>
                                
                        <ng-container matColumnDef="נולד">
                            <th mat-header-cell *matHeaderCellDef style="text-align: center;">נולד </th>
                            <td mat-cell *matCellDef="let m" style="text-align: center;">{{m.nlDay + ' ' + m.nlMonth + ' ' + m.nlYear}} </td>
                          </ng-container>
                    
                        <ng-container matColumnDef="נפטר">
                          <th mat-header-cell *matHeaderCellDef style="text-align: center;"> נפטר </th>
                          <td mat-cell *matCellDef="let m" style="text-align: center;"> {{m.nfDay + ' ' + m.nfMonth + ' ' + m.nfYear}} </td>
                        </ng-container>
                    
                        <ng-container matColumnDef="actions">
                          <th mat-header-cell *matHeaderCellDef>
                            <span style="text-align: center;">
                              <i class="fa fa-gear"></i>
                            </span>
                          </th>
                          <td mat-cell *matCellDef="let m" dir="ltr">
                            <div  class="d-flex">
                                <a (click)="onDelete(m.id)" title="Delete State" style="margin-right: 15px; cursor: pointer">
                                  <i class="fa fa-remove"></i>
                                </a>
                                <a title="Edit State" [href]="'/admin/tzadikim/' + m.id">
                                  <i class="fa fa-edit"></i>
                                </a>
                            </div>
                          </td>

                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      
                        <tr mat-row *matRowDef="let m; columns: displayedColumns;"></tr>
                      
                      </table>
                      
                      <mat-paginator [pageSizeOptions]="[10, 50, 100]"
                                     showFirstLastButtons
                                     aria-label="Select page of periodic elements">
                      </mat-paginator>
                  </div>
            </div>
        </div>  
        </div>
</div> 